import { getFeatureFlagsWithoutToken } from '@/resources/feature-flags-serice.resource';
import { createContext, useEffect, useState } from 'react';

export const FeatureFlagContext = createContext();

export function FeatureFlagProvider({ children }) {
  const [featureFlags, setFeatureFlags] = useState({});
  const fetchFeatureFlags = async () => {
    const featureFlagObject = {};
    try {
      const flags = await getFeatureFlagsWithoutToken();
      flags.forEach(({ feature, isEnabled }) => {
        featureFlagObject[feature] = isEnabled;
      });
    } catch (error) {
      console.error('Error fetching feature flags:', error);
    }

    setFeatureFlags(featureFlagObject);
  };

  useEffect(() => {
    fetchFeatureFlags();
  }, []);

  return (
    <FeatureFlagContext.Provider value={{ featureFlags, fetchFeatureFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
